interface Props {
  completionPercent: number;
  masteryPercent: number;
  size?: 'sm' | 'md' | 'lg';
}

const SIZE = { sm: 48, md: 64, lg: 80 } as const;
const STROKE = { sm: 4, md: 5, lg: 6 } as const;

export function ObjectiveProgressRing({ completionPercent, masteryPercent, size = 'md' }: Props) {
  const dim = SIZE[size];
  const stroke = STROKE[size];
  const r = (dim - stroke * 2) / 2;
  const circ = 2 * Math.PI * r;
  const center = dim / 2;

  const completionDash = (completionPercent / 100) * circ;
  const masteryDash = (masteryPercent / 100) * circ;

  return (
    <svg width={dim} height={dim} className="rotate-[-90deg]" aria-hidden="true">
      {/* Track */}
      <circle cx={center} cy={center} r={r} fill="none" stroke="#e2e8f0" strokeWidth={stroke} />
      {/* Mastery ring (inner) */}
      <circle
        cx={center}
        cy={center}
        r={r - stroke - 2}
        fill="none"
        stroke="#f0a226"
        strokeWidth={stroke - 1}
        strokeDasharray={`${masteryDash} ${circ}`}
        strokeLinecap="round"
      />
      {/* Completion ring (outer) */}
      <circle
        cx={center}
        cy={center}
        r={r}
        fill="none"
        stroke="#5b6bff"
        strokeWidth={stroke}
        strokeDasharray={`${completionDash} ${circ}`}
        strokeLinecap="round"
      />
    </svg>
  );
}
